import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getFunctions } from "firebase/functions";

const firebaseConfig = {
  apiKey: "AIzaSyCK9YZxZmYdmVReLql2t39n5JrY_YgdplI",
  authDomain: "tappoints.firebaseapp.com",
  projectId: "tappoints",
  storageBucket: "tappoints.firebasestorage.app",
  messagingSenderId: "664768630745",
  appId: "1:664768630745:web:3ee744de0fa1bb37c253c8",
  measurementId: "G-CDCMMKLVLP"
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const functions = getFunctions(app, "europe-west2");

export {db, functions}
